import React, {Component} from 'react';
import {
    Collapse, DropdownItem, DropdownMenu, DropdownToggle, Label, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem,
    NavLink,
    UncontrolledDropdown
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToolbox, faUserPlus, faSitemap,faUndo,faUsers, faCommentAlt} from '@fortawesome/free-solid-svg-icons';
import {labels} from "../../util/constants";
import {routes} from "../../util/config";
import renderIf from 'render-if';
import './navBarComponent.css';
import {getSessionState, isLogged, removeTokenUserStorage} from "../../actions";
import {formatShortUserName} from "../../util/tools";

class NavBarComponent extends Component{
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render(){
        return(
            <div>

                <Navbar color="light" light expand="md">
                    <NavbarBrand href="/"><img src={require('../../images/FastFeedback_head_portal_h294px_Artboard_2-06.png')} width="300" height="70" className="d-inline-block align-top img-nav-bar" alt=""/></NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        {
                            renderIf(isLogged())(
                            <Nav className="ml-auto" navbar>
                                <Label className='label-name'>{labels.helloUser} {formatShortUserName(getSessionState().userNameLogged)}{'\u00A0'}</Label>
                                <NavItem>
                                    <NavLink href={routes.users}><FontAwesomeIcon icon={faUsers} />  {'\u00A0'} {labels.users}</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href={routes.experiencesHistory}><FontAwesomeIcon icon={faCommentAlt} />  {'\u00A0'} {labels.experiencesUser}</NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink href={routes.groups}><FontAwesomeIcon icon={faToolbox} />  {'\u00A0'} {labels.groups}</NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink onClick={()=>removeTokenUserStorage()} href="/login"><FontAwesomeIcon icon={faUndo} /> {'\u00A0'} {labels.logout}</NavLink>
                                </NavItem>
                            </Nav>
                            )
                        }
                    </Collapse>
                </Navbar>

            </div>
        )
    }
}

export default NavBarComponent;


// WEBPACK FOOTER //
// ./src/components/navBar/navBarComponent.js